import React from 'react';
import NEXT from '~/constants/NEXT';
import { Electron } from '~/types';
declare global {
  interface Window {
    electron?: Electron;
  }
}
const ElectronListener = (): null => {
  React.useEffect(() => {
    if (NEXT.IS_CLIENT && window.electron) {
      window.electron.receive('message', message => {
        // eslint-disable-next-line no-console
        console.log(message);
      });
      window.electron.send('message', `Hello from Next.js! ${window.location.origin}`);
    }
  }, []);
  return null;
};
export default ElectronListener;